export default class AjaxSvg {
    constructor(){
        this.request = new XMLHttpRequest();
    }
    init(svgPath) {
        this.request.open('GET', svgPath, true);
        this.request.send();
        this.request.onload = this._onload;
    }
    _onload(){
        document.body.insertAdjacentHTML('afterbegin', this.responseText);
    }
};



// WEBPACK FOOTER //
// ./src/main/js/utils/AjaxSvg.js